import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./style.module.scss";

interface SectionTitleProps {
  children: ReactNode;
  size?: "sm" | "md";
  className?: string;
}

/** Block heading used where a full BlockCard header row is not needed. */
function SectionTitle({ children, size = "md", className }: SectionTitleProps) {
  return (
    <div className={classNames(styles.title, styles[size], className)}>
      {children}
    </div>
  );
}

export default SectionTitle;
